// extracted by mini-css-extract-plugin
export var deleteModal = "_rl-0";